import script from "./CreateBoardView.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateBoardView.vue?vue&type=script&setup=true&lang=js"

import "./CreateBoardView.vue?vue&type=style&index=0&id=04174390&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04174390"]])

export default __exports__